import { useAiSlidePanel } from "@redotech/redo-web/ai/chat/contexts/ai-slide-panel-context";
import { memo } from "react";
import { AskRedoButton } from "./ask-redo-button";
import { SearchButton } from "./search-button";
import { TeamSwitcher } from "./team-switcher";

export const MerchantAppTopNav = memo(function MerchantAppTopNav() {
  const { toggle } = useAiSlidePanel();

  return (
    <div className="flex w-full items-center justify-between px-3 py-2 bg-neutral-800 border-b border-neutral-700 overflow-hidden">
      <div className="flex-1 flex items-center justify-start gap-3 min-w-0">
        <TeamSwitcher />
      </div>

      <div className="flex-1 flex items-center justify-center gap-3 min-w-0">
        <SearchButton />
      </div>

      <div className="flex-1 flex items-center justify-end gap-3 min-w-0">
        <AskRedoButton onClick={() => toggle()} />
      </div>
    </div>
  );
});
